module.exports = __webpack_public_path__ + "img/google_star.cb1794b7.svg";